export default function Checkbox({ onChange = () => {}, value = false, label = '' }) {
  return (
    <div className="flex mb-2 gap-2">
      <input
        type="checkbox"
        defaultChecked={value}
        onChange={onChange}
        className="cursor-pointer bg-slate-950"
      />
      <label>{label}</label>
    </div>
  );
}
